module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 1